import { Api } from "./Api";

export default {
  async uploadImg(bodyFormData) {
    return Api.post("/v1/files/uploadImage", bodyFormData, { 
        "Content-Type": "multipart/form-data" 
    });
  },
};